import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ContentGet } from '../../services';

export const fetchContentGet = createAsyncThunk(
    'contentGet/fetchContentGet',
    async () => {
        const response = await ContentGet()
        return response.result
    }
);

const contentGetSlice = createSlice({
    name: 'contentGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContentGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContentGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchContentGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default contentGetSlice.reducer;
